import { PatientFullDetailsType } from "../PatientCare/PatientBooking/v1/types";

export type SetStateFunctionType<T> = (param: T | ((param: T) => T)) => void;
export type FormOnChangeEventType = {
  target: { value: any; name: string };
  type: string;
};

export type PatientDetailsType = PatientFullDetailsType;

export type EmrContextType = {
  patientData: PatientDetailsType;
  dataLoading:boolean
  refetcPatientData:()=>void
  page:string | null
  triggerConsultationStart: () => void;
};


export type submitEmrType={
  clinicId: number;
  userId: number;
  status: number;
  encounterId: number;
  destination:string
}

export const initialData: PatientDetailsType = {
  insurancePatient: null,
  eContactTwo: null,
  companyPatient: "",
  image:"",
  pmaster: {
    lastName: "",
    raceId: 0,
    gender: "",
    patientId: "",
    religionId: 0,
    languageName: null,
    maritalId: 0,
    raceName: null,
    id: 0,
    religionName: null,
    gccId: null,
    foDate: "",
    patientName: "",
    isEstablished: 0,
    maritalName: "",
    languageId: 0,
    priority: 0,
    grouping: null,
    isVip: 0,
    firstName: "",
    passportNum: null,
    dob: "",
    middleName: "",
    emiratesId: "",
    globalConsent: 0,
    a28_msg_status: 0,
    age: "",
    paymentMode:0,
    isRegistered:0,
    bookingConfirmed:0
  },
  patientDetails: {
    encounterId: null,
    doctorId: null,
    departmentId: null,
    pmasterId: null,
    createdDate: null,
    paymentMode: null,
    purposeId: null,
    purposeName: null,
    referBy: null,
    departmentName: null,
    doctorName: null,
    visitType: null,
  },
  eContactOne: "", // or default EmergencyContactType object
  amaster: {
    clinicCountryName: "",
    countryCodeName: null,
    EmiratesID: "",
    address2: null,
    addressType: 0,
    address1: "",
    stateId: 0,
    clinicCountryId: 0,
    mobileNo: "",
    countryId: 0,
    conCode: "",
    stateName: "",
    countryCode: 0,
    uploadfile: "",
    patientMasterID: 0,
    howKnow: "",
    countryName: "",
    place: "",
    addressMasterID: 0,
    email: "",
    photoName:"",
    uploadFlag:false
  },
  encounter: {
    encounterId: null,
    departmentId: null,
    doctorId: null,
    pmasterId: null,
    createdDate: null,
    paymentMode: null,
    purposeId: null,
    purposeName: null,
    referBy: null,
    departmentName: null,
    doctorName: null,
    visitType: null,
    startTime:null,
    endTime:null
  },
  copay: [],
  postOffice: {
    postofficeId: 0,
  },
};

export type ActivitySearchParamsType = {
  encounterId: number;
  poID: number;
  searchText: string;
  groupId: number;
  userId?: number | null;
};

export type ActivitySearchResponseType = {
  cptId: number;
  cptCode: string;
  cptName: string;
  cptDes: string;
  cptRate: number;
  cptGroupId: number;
  insCoverage: number;
  approvalRequired?: number;
  isExclude?: number;
  isFavorite?: number;
};
